// extracted by mini-css-extract-plugin
export default {"bookingDialogTable":"pbLSiokXb0JU4fphglQm","label":"p06DeSod64V2cgmPQIHw","value":"M4DZsnXnD73ZRCHqu8Pe","row":"BgOHCIqLx69XxeH_4Vo5"};